module.exports = __webpack_public_path__ + "img/5_53.aed5fdef.png";